import { useContext } from 'react';
import { AlertContext } from '../providers/alert.provider';

function useAlert() {
  const { message, variant, showAlert } = useContext(AlertContext);
  return { message, variant, showAlert };
}

export default useAlert;
